import { Box } from "@mui/material";
import { ParagraphText } from "../../../../../Libraries";
import moment from "moment";
import { formatNum } from "../../../../../oscar-pos-core/constants";
import { ImgPlaceHolder, RupinFavIcon, RupinNewLogo } from "../../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import styles from "../../TransactionListing/TransactionListing.module.css";

const VoucherVendorTransactionRow = ({ item, onRowClick }) => {
  const {
    created_at,
    voucher_name,
    bill_company,
    display_tran_name,
    extra_info,
    consumer_number_masked,
    consumer_number,
    customer_phone,
    amount,
    mode,
    logo_link,
    type,
  } = item || {};

  const isCredit = mode === "credit";
  const isRupinCashback = type?.toLowerCase() === "commission";
  const phone = isRupinCashback
    ? extra_info || "-"
    : consumer_number_masked || consumer_number || customer_phone || "-";

  return (
    <Box
      id={`voucher_transaction_vendor_txn_row_${item?.id}`}
      className={`invoiceListTableBody accountTableHeaderMain${!isRupinCashback ? " pointer" : ""}`}
      onClick={
        !isRupinCashback
          ? () => {
              triggerLogEvent(analytics, "w_voucher_vendor_txn_transaction_detail");
              onRowClick?.(item);
            }
          : undefined
      }
    >
      <Box className="invListTableHeaderCol fourColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {created_at ? moment(created_at).format("DD MMM YYYY") : "-"}
        </ParagraphText>
      </Box>

      <Box
        className={`invListTableHeaderCol fourColumn textLeft ${styles.contactCell}`}
      >
        {logo_link && !isRupinCashback ? (
          <img
            src={logo_link}
            alt={voucher_name || bill_company || ""}
            className={styles.companyLogo}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : isRupinCashback ? (
          <RupinFavIcon width={20} height={20} />
        ) : (
          <Box className={styles.companyLogoFallback}>
            <ImgPlaceHolder width={20} height={20} />
          </Box>
        )}
        <ParagraphText className="fontSize14 fontWeight400 newFontColor truncateOneLine">
          {isRupinCashback
            ? display_tran_name
            : voucher_name || bill_company || "-"}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fourColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {phone}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fourColumn textRight">
        <ParagraphText
          className={`fontSize14 ${isCredit ? styles.creditAmount : styles.debitAmount}`}
        >
          {isCredit ? "+" : "-"}Rs. {formatNum(Math.abs(amount || 0))}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default VoucherVendorTransactionRow;
